import { useEffect, useState, MutableRefObject } from 'react';

export const useIsVisibleOnScreen = (
  ref: MutableRefObject<HTMLDivElement | null>,
  rootMargin = '0px'
) => {
  // State and setter for storing whether element is visible
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const currentRef = ref.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        // Update our state when observer callback fires
        setIsVisible(entry.isIntersecting);
      },
      {
        rootMargin,
      }
    );
    if (currentRef) {
      observer.observe(currentRef);
    }
    return () => {
      if (currentRef) observer.unobserve(currentRef);
    };
  }, [ref, rootMargin]);

  return isVisible;
};
